import * as React from 'react'
import { Icon, bellFilled, bellOutline, Link, cross } from '../../../../components'
import { Notification } from '../../../../models/notification'
import classNames from 'classnames'
import bind from 'bind-decorator'
import moment from 'moment'
import { isMessagingSupported } from '../../../../services/notifications'
import './Notifications.scss'

export type FieldProps = {
    notifications: Notification[]
    notificationCount: number
    notificationsShown: boolean
}

export type MethodProps = {
    showNotificationArea: () => void
    hideNotificationArea: () => void
}

type Props = FieldProps & MethodProps

class Notifications extends React.Component<Props> {
    @bind
    toggleNotifications(e: React.MouseEvent) {
        const { notificationsShown, notificationCount, showNotificationArea, hideNotificationArea } = this.props

        e.preventDefault()

        if (notificationsShown) {
            hideNotificationArea()
        } else if (notificationCount > 0) {
            showNotificationArea()
        }
    }

    render() {
        const { notifications, notificationCount, notificationsShown } = this.props
        const hasNotifications = notificationCount > 0
        const classes = classNames(
            'notifications',
            {
                'notifications--open': notificationsShown,
                'notifications--has-notifications': hasNotifications,
            }
        )

        if (!isMessagingSupported()) {
            return null
        }

        return (
            <div className={classes}>
                <Icon
                    icon={hasNotifications ? bellFilled : bellOutline}
                    className='notifications__trigger'
                    data-count={notificationCount}
                    onClick={this.toggleNotifications}
                />
                <div className='notifications__dropdown'>
                    <ul className='notifications__list'>
                        {notifications.map((notification, index) => (
                            <li
                                className='notifications__notification'
                                key={index}
                                data-notification-id={notification.id}
                            >
                                <h3 className='notifications__heading'>
                                    <Link to={notification.url} target='_blank' className='notifications__link'>
                                        {notification.title}
                                    </Link>
                                    {notification.isNew && (
                                        <span className='notifications__new'>new</span>
                                    )}
                                </h3>
                                <p className='notifications__date'>
                                    {moment(notification.sent).format('DD/MM/YYYY h:mm')}
                                </p>
                                <p className='notifications__body'>{notification.body}</p>
                            </li>
                        ))}
                    </ul>
                    <Icon icon={cross} className='notifications__close' onClick={this.toggleNotifications} />
                </div>
            </div>
        )
    }
}

export { Notifications }
